/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  BrandBrandProtocolAddBrandRequest,
  BrandBrandProtocolDeleteBrandRequest,
  BrandBrandProtocolGetAssetCountRequest,
  BrandBrandProtocolGetAssetCountResponse,
  BrandBrandProtocolGetBrandListResponse,
  BrandBrandProtocolGetIpTmByBrandRequest,
  BrandBrandProtocolGetIpTmByBrandResponse,
  BrandBrandProtocolUpdateBrandRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Brand<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Brand
   * @name PostBrand
   * @request POST:/brand/add
   */
  postBrand = (data: BrandBrandProtocolAddBrandRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/brand/add`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Brand
   * @name ListList
   * @request GET:/brand/list
   */
  listList = (params: RequestParams = {}) =>
    this.http.request<BrandBrandProtocolGetBrandListResponse, any>({
      path: `/brand/list`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Brand
   * @name UpdateCreate
   * @request POST:/brand/update
   */
  updateCreate = (data: BrandBrandProtocolUpdateBrandRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/brand/update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Brand
   * @name DeleteCreate
   * @request POST:/brand/delete
   */
  deleteCreate = (data: BrandBrandProtocolDeleteBrandRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/brand/delete`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Brand
   * @name AssetCountCreate
   * @request POST:/brand/asset/count
   */
  assetCountCreate = (data: BrandBrandProtocolGetAssetCountRequest, params: RequestParams = {}) =>
    this.http.request<BrandBrandProtocolGetAssetCountResponse, any>({
      path: `/brand/asset/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Brand
   * @name IpTmListCreate
   * @request POST:/brand/ipTm/list
   */
  ipTmListCreate = (data: BrandBrandProtocolGetIpTmByBrandRequest, params: RequestParams = {}) =>
    this.http.request<BrandBrandProtocolGetIpTmByBrandResponse, any>({
      path: `/brand/ipTm/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
